var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.1826L5.002 1L9 2.1826V4.60765C9 7.15645 7.38889 9.19427 5.00067 10C2.61178 9.1945 1 7.156 1 4.60652V2.1826Z",
    stroke: "#282828",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99978 5.27502C5.61343 5.27502 6.11089 4.77134 6.11089 4.15002C6.11089 3.5287 5.61343 3.02502 4.99978 3.02502C4.38613 3.02502 3.88867 3.5287 3.88867 4.15002C3.88867 4.77134 4.38613 5.27502 4.99978 5.27502Z",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77724 7.07502C6.77724 6.59763 6.58993 6.1398 6.25654 5.80223C5.92314 5.46467 5.47095 5.27502 4.99946 5.27502C4.52796 5.27502 4.07578 5.46467 3.74238 5.80223C3.40898 6.1398 3.22168 6.59763 3.22168 7.07502",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomer);
export default __webpack_public_path__ + "static/media/icon-customer.1eebfab4aef6ce3992b7a819510dbfc3.svg";
export { ForwardRef as ReactComponent };